module.exports = __webpack_public_path__ + "static/media/campaignEffectiveness-01.91687e07.png";